<template>
  <vs-popup id="popupRiskInfo1" title="가능성(빈도)" :active.sync="popupActiveSync">
    <div class="p-4">
      <div class="risk-info-header">
        <span style="border-right: none;">가능성(빈도)</span>
        <span>내용</span>
      </div>
      <div>
        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">3</span>
          <span style="border-top: none; display: block;">일반적 또는 반복적으로 발생</span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">2</span>
          <span style="border-top: none; display: block;">발생 가능성 있음</span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">1</span>
          <span style="border-top: none; display: block;">발생 가능성 거의 없음</span>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskInfoEp1_3x3',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-header,
.risk-info-body {
  display: grid;
  grid-template-columns: 109px 1fr;
}
.risk-info-body {
  span {
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  //display: grid;
  //grid-template-columns: 109px 109px 109px 572px 236px;
  //grid-template-areas: "A A A B C" "D E F B C";
  //grid-template-rows: 40px 40px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #DEDEDE;
  }
}
</style>
<style>

#popupRiskInfo1 > .vs-popup {
  width: 600px !important;
}

#popupRiskInfo1 > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo1 > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
